// extracted by mini-css-extract-plugin
export default {"wrapper":"addbtn_wrapper__Ck7EA","btn":"addbtn_btn__+AwMx","or":"addbtn_or__6nHAN","ex":"addbtn_ex__6Q-ox"};